import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../button/back";

const Baca = () => {
  const { id } = useParams();
  const [buku, setBuku] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBuku = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL_PERPUSTAKAAN}api/buku`
        );
        const found = res.data.find((item) => item._id === id);
        if (!found) throw new Error("Buku tidak ditemukan");
        setBuku(found);
      } catch (err) {
        setError(err.message || "Terjadi kesalahan");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchBuku();
  }, [id]);

  if (loading) return <div className="p-4">📖 Memuat buku...</div>;
  if (error) return <div className="p-4 text-red-600">❌ {error}</div>;
  if (!buku) return <div className="p-4">Buku tidak tersedia.</div>;

  // 🔍 Cek sumber file/link
  let fileUrl = null;

  if (buku.link) {
    if (buku.link.includes("drive.google.com")) {
      const match = buku.link.match(/\/d\/([^/]+)/);
      const fileId = match?.[1];
      if (fileId) {
        fileUrl = `https://drive.google.com/file/d/${fileId}/preview`;
      }
    } else {
      fileUrl = buku.link;
    }
  } else if (buku.filename) {
    fileUrl = `${process.env.REACT_APP_API_URL_PERPUSTAKAAN}api/buku/file/${buku.filename}`;
  }

  if (!fileUrl) {
    return (
      <div className="p-4 text-yellow-600">
        ⚠️ Buku belum memiliki file atau link yang valid.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col p-4">
      <div className="pt-5 pb-5 pl-5">
        <Link to="/perpustakaan">
          <Back />
        </Link>
      </div>
      <h1 className="text-xl font-bold text-center mb-4">{buku.judul}</h1>
      <div className="flex-grow">
        <iframe
          src={fileUrl}
          title={`Buku: ${buku.judul}`}
          className="w-full h-[100vh] rounded shadow border"
          allow="autoplay"
        ></iframe>
      </div>
    </div>
  );
};

export default Baca;
